// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__39QDW","footer":"ModalInfo_footer__1WoWK"};